import { useRef, useCallback } from 'react';
import { useIsMobile } from './useMediaQuery';

/**
 * Back Gesture Hook — detects swipe from left edge to navigate back.
 * Only active on mobile. Desktop: no-op.
 * 
 * Usage: Add {...backGestureHandlers} to the main content wrapper.
 */
export function useBackGesture() {
  const isMobile = useIsMobile();
  const startX = useRef(0);
  const startY = useRef(0);
  const swiping = useRef(false);

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    if (!isMobile) return;
    const touch = e.touches[0];
    // Only trigger if starting from left 20px edge
    if (touch.clientX <= 20) {
      startX.current = touch.clientX;
      startY.current = touch.clientY;
      swiping.current = true;
    }
  }, [isMobile]);

  const onTouchEnd = useCallback((e: React.TouchEvent) => {
    if (!swiping.current || !isMobile) return;
    swiping.current = false;
    const touch = e.changedTouches[0];
    const diffX = touch.clientX - startX.current;
    const diffY = Math.abs(touch.clientY - startY.current);
    
    // Must swipe right at least 80px, and horizontal > vertical
    if (diffX > 80 && diffX > diffY * 2) {
      window.history.back();
    }
  }, [isMobile]);

  return {
    onTouchStart,
    onTouchEnd,
  };
}
